<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal modal--welcomeback" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1>{{ getTranslations.home_modals_resubscribe_via_sms_do_you_want }}</h1>
          <!--h2>$#Your points: <span class="points">XXX</span></h2>
          <h2>$#Your level: <span class="level">Y</span></h2-->
          <img :src="getTranslations.project_config_modal_img" alt="">
        </div>
        <div class="modal__body">
          {{ getTranslations.home_modals_resubscribe_via_sms_by_resubscribing_you_will }}
          <br><br>
          {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_resub_resubscribe_questions_via_sms') }}
        </div>
        <div class="modal__footer">
          <!--a href="#" class="btn2 btn2--std btn2--small">$#Re-Subscribe</a>
          <span class="terms">
          $#By clicking “Re-Subscribe” you agree to the<br>
          <a href="#">T &amp; Cs</a> of the service
          </span-->
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  // modal_resubscribe_request_SMS.html
  name: 'resubscribe-question',
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeQuestionViaSms.vue